import React from 'react';

import { useTranslation } from 'react-i18next';

import SkillsSection from './SkillsSection/SkillsSection';

import './Skills.css';

import renderText from '../../common/utilities/text/renderText';

import SectionContainer from '../../common/SectionContainer/SectionContainer';

import useRequest from '../../common/hooks/useRequest';

import DataLoading from '../../common/DataLoading/DataLoading';

import DataError from '../../common/DataError/DataError';

import { skillsDataURL } from '../../common/utilities/URLs/getURLs';

import { SkillsDataType } from '../../common/types';



const SkillsComponent = () => {

  const { t } = useTranslation();

  const { data: myData, isLoading, error, retryFetchData } =

    useRequest<SkillsDataType>(skillsDataURL);



  let body: React.ReactNode = null;



  if (error) {

    body = <DataError retryFetchData={ retryFetchData } />;

  } else if (isLoading) {

    body = <DataLoading />;

  } else if (myData) {

    body = (

      <div className='Skills'>

        <SkillsSection key='frontend' data={ myData.frontend } slug='frontend' />

        <SkillsSection key='backend' data={ myData.backend } slug='backend' />

        <SkillsSection key='other' data={ myData.other } slug='other' />

        <SkillsSection key='past' data={ myData.past } slug='past' />

        <hr />

        { renderText(t('skills.text', { returnObjects: true })) }

      </div>

    );

  }



  return (

    <SectionContainer titleSlug='skills' isCollapsible>

      { body }

    </SectionContainer>

  );

};



export default SkillsComponent;

